export const isValidGSTNumber = (input, errors) => {
    const gstRegex = new RegExp('^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$', 'igm');
    const isValid = gstRegex.test(input);
    if (isValid) {
        return input
    } else {
        throw new Error("GST Number format is not correct")
    }
}